import { Grid, IconButton, Paper, Tooltip } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { SaveButton, SimpleForm, Tab, TabbedShowLayout, Toolbar, useDataProvider } from "react-admin";
import { useHistory, useLocation } from "react-router-dom";
import { RequestType } from "../../../../Enums/RequestType";
import { RequestFileType } from "../../../../Enums/RequestFileType";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import RequestHistoryTimeLine from "../RequestHistoryTimeLine";
import { ModelState } from "../../Models/ModelStateEnum";
import RequestAlternatePn from "../RequestAlternatePn/RequestAlternatePn";
import RequestServiceable from "../RbhRequestServiceable/RbhRequestServiceable";
import RequestServiceableRedelivery from "../RequestServiceableRedelivery/RequestServiceableRedelivery";
import RequestShipmentArrival from "../RequestShipmentArrival/RequestShipmentArrival";
import RbhRequestUnserviceable from "../RbhRequestUnserviceable/RbhRequestUnserviceable";
import "./RbhRequestOrderEdit.css";
import RequestSpt from "../RequestSpt/RequestSpt";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import { SourceRequestOrder } from "../../Constant/Source";
import RbhRequestFiles from "./RbhRequestFiles";
import RbhRequestOrderInfo from "../Info/RbhRequestOrderInfo";
import CloudDownload from "@material-ui/icons/CloudDownload";
import { useAppDataProvider } from "../../../../dataprovider";
import {
  RequestOrderHistoryExcelName,
  RequestOrderHistoryHeaders,
  RequestServiceableHistoryExcelName,
  RequestServiceableHistoryHeaders,
  RequestUnserviceableHistoryExcelName,
  RequestUnserviceableHistoryHeaders,
} from "./Rbh.constants";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import Swal from "sweetalert2";

const ExportToExcelUnsvc = data => {
  ExcelExport(
    RequestUnserviceableHistoryHeaders,
    data.map(v => [
      v.pn,
      v.sn,
      v?.estimatedDeliveryDate != null ? v?.estimatedDeliveryDate : "",
      v.tso,
      v.cso,
      v.tsr,
      v.csr,
      v.tsn,
      v.csn,
      v.dsn,
      v.tsi,
      v.csi,
      v.dsi,
      v.createdBy,
      v.updatedBy,
      v?.createdDate != null ? v?.createdDate : "",
      v?.updatedDate != null ? v?.updatedDate : "",
      v.removeDateFromAc != null ? v?.removeDateFromAc : "",
      v.status,
      v?.submittedDate != null ? v?.submittedDate : "",
      v.carrier,
      v.dso,
      v.removeReasonRemark,
      v.removeReasonSubCategory,
      v.removeReason,
      v?.flightDate != null ? v?.flightDate : "",
      v.airportCode,
      v.removeFromAc,
      v?.ordinoDate != null ? v?.ordinoDate : "",
    ]),
    RequestUnserviceableHistoryExcelName
  );
};

const ExportToExcelSvc = data => {
  ExcelExport(
    RequestServiceableHistoryHeaders,
    data.map(v => [
      v.createdBy,
      v?.createdDate != null ? v?.createdDate : "",
      v.updatedBy,
      v?.updatedDate != null ? v?.updatedDate : "",
      v.pn,
      v.sn,
      v.awb,
      v.flightNo,
      v.requestedDeliveryDate != null ? v?.updatedDate : "",
      v.estimatedDeliveryDate != null ? v?.estimatedDeliveryDate : "",
      v.submittedBy,
      v.submittedDate != null ? v?.submittedDate : "",
      v.carrier,
      v.flightDate != null ? v?.flightDate : "",
    ]),
    RequestServiceableHistoryExcelName
  );
};

const ExportToInfoExcelInfo = data => {
  ExcelExport(
    RequestOrderHistoryHeaders,
    data.map(v => [
      v.refNo,
      v.isDefined,
      v.requestedDeliveryDate != null ? v?.requestedDeliveryDate : "",
      v.chapter,
      v.releaseType,
      v.airportCode,
      v.customerPo,
      v.customerPoLine,
      v.createdBy,
      v.updatedBy,
      v.createdDate != null ? v?.createdDate : "",
      v.updatedDate != null ? v?.updatedDate : "",
      v.pn,
      v.componentDescription,
      v.access,
      v.repair,
      v.isPool,
      v.repairTat,
      v.receivedDate != null ? v?.receivedDate : "",
      v.transactionType,
    ]),
    RequestOrderHistoryExcelName
  );
};
const historyResource = [
  {
    id: RequestOrderTabEnum.ServiceableTab,
    source: "requestserviceables/svchistory",
    exportFunction: ExportToExcelSvc,
  },
  {
    id: RequestOrderTabEnum.UnServiceableTab,
    source: "requestunserviceables/unsvchistory",
    exportFunction: ExportToExcelUnsvc,
  },
  {
    id: RequestOrderTabEnum.InfoTab,
    source: "requestorders/history",
    exportFunction: ExportToInfoExcelInfo,
  },
];

const RbhRequestOrderEdit = props => {
  var historyState = {};
  const location = useLocation();
  const provider = useDataProvider();
  const dataProvider = useAppDataProvider();
  const history = useHistory();
  const { user } = useAuth();
  const [requestDetail, setRequestDetail] = useState(null as any);
  const [alternatePn, setAlternatePn] = useState([] as any);
  const [requestRedelivery, setRequestRedelivery] = useState([] as any);
  const [shipmentArrival, setShipmentArrival] = useState({} as any);
  const [requestSpt, setRequestSpt] = useState([] as any);
  const [getFileGrid, setValueFileGrid] = useState({} as boolean);
  const [activeTab, setActiveTab] = useState(RequestOrderTabEnum.InfoTab.toString() as string);
  const [selectedRequestOrderFileType, setSelectedRequestOrderFileType] = useState(0 as number);
  const requestId: string = location?.pathname?.split("/")[2];
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const { canPerform: canServiceableCreate } = useAccessControl(SourceRequestOrder, "rbhserviceabletabcreate");
  const { canPerform: canUnserviceableCreate } = useAccessControl(SourceRequestOrder, "rbhunserviceabletabcreate");
  const { canPerform: canAlternatePnCreate } = useAccessControl(SourceRequestOrder, "rbhalternatepntabcreate");
  const { canPerform: canShipmentArrival } = useAccessControl(SourceRequestOrder, "rbhshipmentarrivaltab");
  const { canPerform: canSpt } = useAccessControl(SourceRequestOrder, "rbhspttab");

  React.useEffect(() => {
    let currentTab = location?.pathname?.split?.("/")?.[3];
    currentTab = currentTab ? currentTab : RequestOrderTabEnum.InfoTab.toString();
    if (currentTab !== activeTab) {
      setSelectedRequestOrderFileType(
        currentTab === getTabEnumValue(RequestOrderTabEnum.UnServiceableTab)
          ? RequestFileType.ShippingInvoice
          : requestDetail?.requestStatus === Number(RequestStatus.NotPool)
            ? RequestFileType.AarScopeInvestigation
            : RequestFileType.AarProvideNecessary
      );
      setActiveTab(currentTab);
    }
  }, [location?.pathname]);
  React.useEffect(() => {
    if ((history as any)?.location?.state) {
      historyState = (history as any)?.location?.state;
    }
    return () => {
      if (history.location.pathname === "/requestorders/list") {
        history.replace({
          pathname: `/requestorders/list`,
          state: historyState,
        });
      }
    };
  }, []);

  React.useEffect(() => {
    getRequestDetail();
    getAlternatePn();
    getRequestRedelivery();
    getShipmentArrival();
    getRequestSpt();
  }, [requestId]);

  const getRequestDetail = async () => {
    provider
      .getOne("requestorders", {
        id: requestId,
      })
      .then(response => {
        if (response?.data?.id === 0) {
          Swal.fire({
            title: "Error!",
            text: "Data not found",
            icon: "warning",
            iconColor: "#c80c0f",
            confirmButtonText: "Ok",
            confirmButtonColor: "#c80c0f",
          }).finally(() => {
            history.goBack();
          });
        } else {
          setRequestDetail(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const getTablesHistory = async (source: string, key: number) => {
    return dataProvider.getRequestTablesHistoryList(source, key);
  };

  const getAlternatePn = async () => {
    const { data } = await provider.getList("requestalternatepns", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "DESC" },
      filter: { requestId__eq: requestId },
    });
    if (data.length > 0) {
      setAlternatePn(data);
    } else {
      setAlternatePn(null);
    }
  };

  const getRequestRedelivery = async () => {
    const { data } = await provider.getList("requestredeliverys", {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "DESC" },
      filter: { requestId__eq: requestId },
    });
    if (data.length > 0) {
      setRequestRedelivery(data[0]);
    } else {
      setRequestRedelivery(null);
    }
  };

  const getShipmentArrival = async () => {
    const { data } = await provider.getList("requestarrivalinfos", {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "DESC" },
      filter: { requestId__eq: requestId },
    });
    if (data.length > 0) {
      setShipmentArrival(data[0]);
    } else {
      setShipmentArrival(null);
    }
  };

  const getRequestSpt = async () => {
    const { data } = await provider.getList("requestspts", {
      pagination: { page: 1, perPage: 99 },
      sort: { field: "id", order: "DESC" },
      filter: { requestId__eq: requestId },
    });
    if (data.length > 0) {
      setRequestSpt(data);
    } else {
      setRequestSpt([]);
    }
  };

  const serviceableCallBack = async e => {
    getRequestDetail();
  };
  const unserviceableCallBack = async e => {
    getRequestDetail();
  };
  const alternatePnCallBack = async e => {
    await getAlternatePn().then(() => {
      getRequestDetail();
    });
  };
  const requestRedeliveryCallBack = async e => {
    await getRequestRedelivery().then(() => {
      getRequestDetail();
    });
  };
  const shipmentArrivalCallBack = async () => {
    await getShipmentArrival().then(() => {
      getRequestDetail();
    });
  };

  const requestSptCallBack = async () => {
    await getRequestSpt().then(() => {
      getRequestDetail();
    });
  };

  const onHandleFileExecute = async () => {
    setValueFileGrid(true);
  };

  const onFileGridRefresh = async () => {
    setValueFileGrid(false);
  };

  const changeRequestOrderFileType = value => {
    setSelectedRequestOrderFileType(value.target.value);
  };

  const getTabEnumValue = (value: RequestOrderTabEnum): string => {
    if (value === RequestOrderTabEnum.InfoTab) {
      return "";
    }
    return Number(value).toString();
  };

  const isAttachmentVisible = (): boolean => {
    let currentTab: string = activeTab;
    switch (currentTab) {
      case getTabEnumValue(RequestOrderTabEnum.InfoTab):
        return true;
      case getTabEnumValue(RequestOrderTabEnum.ServiceableTab):
        return true;
      case getTabEnumValue(RequestOrderTabEnum.UnServiceableTab):
        return true;
      default:
        return false;
    }
  };

  const historyButtonVisible = (): boolean => {
    if (user?.isCustomer) return false;
    let tab = Number(activeTab);
    if (!historyResource.find(x => x.id == tab)) return false;
    if (tab === RequestOrderTabEnum.UnServiceableTab && requestDetail?.requestUnserviceable === null) return false;
    if (tab === RequestOrderTabEnum.ServiceableTab && requestDetail?.requestServiceable === null) return false;

    return true;
  };

  const BlankToolbar = props => (
    <Toolbar placeholder="" {...props} className="blank-toolbar">
      {canEditOnlyShow === false && <SaveButton label="" />}
    </Toolbar>
  );

  const exportHistory = e => {
    let selectedResource = historyResource.filter(condition => condition.id === Number(activeTab))[0];
    let key =
      selectedResource.id === RequestOrderTabEnum.UnServiceableTab
        ? requestDetail.requestUnserviceable.id
        : selectedResource.id === RequestOrderTabEnum.ServiceableTab
          ? requestDetail.requestServiceable.id
          : requestDetail.id;
    getTablesHistory(selectedResource.source, key).then((response: any) => {
      let data = response.data;
      selectedResource.exportFunction(data);
    });
  };
  const serviceableTabVisible = () => {
    const isVisible =
      (requestDetail?.requestServiceable === null && canServiceableCreate) ||
      requestDetail?.requestServiceable !== null;
    return isVisible;
  };
  const unserviceableTabVisible = () => {
    const isVisible =
      (requestDetail?.requestUnserviceable === null && canUnserviceableCreate) ||
      requestDetail?.requestUnserviceable !== null;
    return isVisible;
  };
  const alternatePnTabVisible = () => {
    const isVisible = (alternatePn === null && canAlternatePnCreate) || alternatePn?.length > 0;
    return isVisible;
  };
  const serviceableRedeliveryTabVisible = () => {
    const isVisible =
      (requestRedelivery === null && canEditOnlyShow) === false &&
      ((user?.isCustomer === false && requestDetail?.requestStatus === RequestStatus.RequestRedeliveryOffered) ||
        (user?.isCustomer && requestDetail?.requestStatus !== RequestStatus.RequestRedeliveryOffered));
    return isVisible;
  };
  const shipmentArrivalTabVisible = () => {
    const isVisible = canShipmentArrival && requestDetail?.requestUnserviceable != null;
    return isVisible;
  };
  const sptTabVisible = () => {
    const isVisible = canSpt && requestDetail?.requestType === RequestType.RBH;
    return isVisible;
  };
  const canRemove = (): boolean => {
    if (activeTab !== getTabEnumValue(RequestOrderTabEnum.UnServiceableTab) && canEditOnlyShow) return false;
    return true;
  };

  return (
    <SimpleForm submitOnEnter={false} toolbar={<BlankToolbar />}>
      <Grid container spacing={2} style={{ width: "100%" }}>
        <Grid item xs={12} sm={9}>
          <form>
            <Paper>
              <>
                <TabbedShowLayout value={1}>
                  {(requestDetail !== null || canEditOnlyShow) && (
                    <Tab id="info" key="info" label="INFO">
                      <RbhRequestOrderInfo ModelState={ModelState.View} DataSource={requestDetail} />
                    </Tab>
                  )}
                  {serviceableTabVisible() && (
                    <Tab
                      id="serviceable"
                      key="serviceable"
                      label="SERVICEABLE"
                      path={getTabEnumValue(RequestOrderTabEnum.ServiceableTab)}
                    >
                      <RequestServiceable
                        requestId={requestId}
                        requestDetailData={requestDetail}
                        requestServiceableData={requestDetail?.requestServiceable}
                        parentCallBack={serviceableCallBack}
                      />
                    </Tab>
                  )}
                  {unserviceableTabVisible() && (
                    <Tab
                      id="unserviceable"
                      key="unserviceable"
                      label="CORE UNIT"
                      path={getTabEnumValue(RequestOrderTabEnum.UnServiceableTab)}
                    >
                      <RbhRequestUnserviceable
                        requestId={requestId}
                        requestDetailData={requestDetail}
                        requestUnserviceableData={requestDetail?.requestUnserviceable}
                        parentCallBack={unserviceableCallBack}
                      />
                    </Tab>
                  )}
                  {alternatePnTabVisible() && (
                    <Tab
                      id="alternatepn"
                      key="alternatepn"
                      label="ALTERNATE OR REPLACEMENT PN"
                      path={getTabEnumValue(RequestOrderTabEnum.AlternatePnTab)}
                    >
                      <RequestAlternatePn
                        requestId={requestId}
                        requestAlternatePn={alternatePn}
                        requestDetailData={requestDetail}
                        parentCallBack={alternatePnCallBack}
                      />
                    </Tab>
                  )}
                  {serviceableRedeliveryTabVisible() && (
                    <Tab
                      id="serviceableredelivery"
                      key="serviceableredelivery"
                      label="SERVICEABLE REDELIVERY"
                      path={getTabEnumValue(RequestOrderTabEnum.ServiceableReDeliveryTab)}
                    >
                      {requestRedelivery === null && canEditOnlyShow === false ? (
                        <RequestServiceableRedelivery
                          ModelState={ModelState.Create}
                          requestId={requestId}
                          requestServiceableRedelivery={requestRedelivery}
                          requestDetailData={null}
                          parentCallBack={requestRedeliveryCallBack}
                        />
                      ) : requestRedelivery?.status == RequestStatus.RequestRedeliveryOffered ? (
                        <RequestServiceableRedelivery
                          ModelState={ModelState.Edit}
                          requestId={requestId}
                          requestServiceableRedelivery={requestRedelivery}
                          requestDetailData={requestDetail}
                          parentCallBack={requestRedeliveryCallBack}
                        />
                      ) : (
                        <RequestServiceableRedelivery
                          ModelState={ModelState.View}
                          requestId={requestId}
                          requestServiceableRedelivery={requestRedelivery}
                          requestDetailData={requestDetail}
                        />
                      )}
                    </Tab>
                  )}
                  {shipmentArrivalTabVisible() && (
                    <Tab
                      id="shipmentarrival"
                      key="shipmentarrival"
                      label="SHIPMENT ARRIVAL"
                      path={getTabEnumValue(RequestOrderTabEnum.ShipmentArrivalTab)}
                    >
                      <RequestShipmentArrival
                        flightDate={requestDetail.requestUnserviceable?.flightDate}
                        requestId={requestId}
                        requestShipmentArrivalInfo={shipmentArrival}
                        requestDetailData={requestDetail}
                        parentCallBack={shipmentArrivalCallBack}
                      />
                    </Tab>
                  )}
                  {sptTabVisible() && (
                    <Tab
                      id="requestspt"
                      key="requestspt"
                      label="SPT UPDATE"
                      path={getTabEnumValue(RequestOrderTabEnum.RequestSpt)}
                    >
                      <RequestSpt
                        ModelState={ModelState.Create}
                        requestId={requestId}
                        requestSpt={requestSpt}
                        requestDetailData={requestDetail}
                        parentCallBack={requestSptCallBack}
                      />
                    </Tab>
                  )}

                  {historyButtonVisible() && (
                    <IconButton
                      {...props}
                      size="medium"
                      style={{
                        color: "#c80c0f",
                        margin: "auto",
                        marginRight: "unset",
                      }}
                      onClick={exportHistory}
                    >
                      <Tooltip title="History Export">
                        <CloudDownload />
                      </Tooltip>
                    </IconButton>
                  )}
                </TabbedShowLayout>
              </>
            </Paper>
            <RbhRequestFiles
              isAttachmentVisible={isAttachmentVisible}
              canRemove={canRemove}
              selectedRequestOrderFileType={selectedRequestOrderFileType}
              activeTab={activeTab}
              getTabEnumValue={getTabEnumValue}
              requestDetail={requestDetail}
              changeRequestOrderFileType={changeRequestOrderFileType}
              onHandleFileExecute={onHandleFileExecute}
              getRequestDetail={getRequestDetail}
              onFileGridRefresh={onFileGridRefresh}
              getFileGrid={getFileGrid}
              requestId={requestId}
            />
          </form>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Paper>
            <Tab id="history" key="history" label="HISTORY">
              <RequestHistoryTimeLine request={requestDetail} />
            </Tab>
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

export default RbhRequestOrderEdit;
